export default function SaveFindingConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveFindingDialog = _handleSaveFindingDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    loaderService.showViewLoader = false;
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.saveFindingConfirmDialog);
  }

  function _handleSaveFindingDialog() {
    return amSharedModelService.saveFinding(vm.finding)
      .then(() => {
        alerts.success('The Finding has been saved successfully.');
        if (vm.finding.findingId > 0) {
          $rootScope.$broadcast('refreshAMFinding', { findingId: vm.finding.findingId });
        } else {
          $rootScope.$broadcast('refreshAMFindings', { findingCategoryId: vm.finding.findingCategoryId });
        }
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.saveFindingConfirmDialog);
      })
      .catch(() => {
        alerts.error('Error occurred while saving the Finding.');
      });
  }
}

SaveFindingConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
